export const config = {
  API_BASE_URL_TEST: "https://testapi.finpass.eu/api",
  API_BASE_URL_PROD: "https://api.finpass.eu/api",

  API_ENDPOINTS: {
    GetReport: (companyCode) => `/reports/${companyCode}/short`,
  },
};
